<template>
<div>
    <title>结算管理</title>
    <section class="mainPart">
        <!--S 公用头部切换-->
        <CompanyTabJsz :active="currentTit" :flowcode="flowcode"></CompanyTabJsz>
        <!--E 公用头部切换-->
        <div class="flexUpDownCenter pt64">
            <ul class="quotaWrap">
                <li v-if="sellType==1"> <!--分销商的-->
                    <em>授信额度(￥)</em>
                    <strong class="priceFont blueColor">{{details.curcanusequota |formatAmount}}</strong>
                </li>
                <li v-else><!--门店内部-->
                    <em>授信额度(￥)</em>
                    <strong class="priceFont blueColor">{{(Number(details.quota||0) -Number(detailsTotal.dtquota ||0))|formatAmount}}</strong>
                </li>
                <li>
                    <em>已使用额度(￥)</em>
                    <strong class="priceFont orangeColor">{{details.usedquota|formatAmount}}</strong>
                </li>
                <li>
                    <em>剩余额度(￥)</em>
                    <strong class="priceFont redColor">{{details.surplusquota|formatAmount}}</strong>
                </li>
            </ul>
            <!-- 仅在供应方显示 -->
            <p>
                <el-popover placement="bottom-start" width="400" trigger="click" @show="getShowAdd">
                    <el-form class="settleForm" :model="settleForm" label-width="80px">
                        <el-form-item label="还款额度" class="pt20">
                            <el-input v-model="settleForm.quota" @input="quotas" maxlength="9" clearable>
                                <i slot="prepend">￥</i>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="备注">
                            <el-input type="textarea" placeholder="填写备注" maxlength="50"  v-model="settleForm.memo"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="center">
                        <el-button type="primary" size="mini" :loading="showHk" @click="updateStoredisquota">确定</el-button>
                        <el-button size="mini" @click="getClosePop">取消</el-button>
                    </div>
                    <el-button type="primary" slot="reference" v-show="sellType==1&&details!=''&&(details.usedquota!=null&&details.usedquota>0)">账单还款</el-button><!-- 门店系统的账户信息和分销系统的账户信息里没有 -->
                </el-popover>
            </p>
        </div>
        <!-- 检索条件 s -->
        <el-form :inline="true" class="cardForm" :model="distributeForm" v-show="details!=''">
            <el-form-item label="交易时间">
              <!-- S 双日期选择器 -->
              <TwoDatePicker :noQuick="1" @twoDateObtain="twoDateReceive" :startvaldate="startvaldate" :endvaldate="endvaldate"></TwoDatePicker>
              <!-- E 双日期选择器 -->
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="search">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- 检索条件 e -->
        <!--table表格 s-->
        <el-table v-show="details!=''"  v-loading="loading" :data="storedisquotachangeList" class="comTable" border ref="gsTable" :maxHeight="tableHeight">
            <el-table-column label="序号" type="index"></el-table-column> 
            <el-table-column label="交易时间" sortable prop="changedate" min-width="120">
                <template slot-scope="scope">
                  {{dateTime(scope.row.changedate,1)}}
                </template>
            </el-table-column>
            <el-table-column label="账单结算(￥)" sortable prop="amount" min-width="120">
                <template slot-scope="scope">
                    <p class="textFl commonNum" :title="scope.row.amount">{{scope.row.amount |formatAmount}}</p>
                </template>
            </el-table-column>
            <el-table-column label="账单来源" sortable prop="flowname" min-width="100">
                <template slot-scope="scope">
                    <p>{{scope.row.flowname}}</p>
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作时间" sortable prop="changedate" min-width="100">
                <template slot-scope="scope">
                    <p>{{dateTime(scope.row.changedate,1)}}</p>
                </template>
            </el-table-column>    -->
            <el-table-column label="备注" sortable prop="memo" min-width="120">
                <template slot-scope="scope">
                    <p class="textFl" :title="scope.row.memo">{{scope.row.memo ||'--'}}</p>
                </template>
            </el-table-column>
            <template slot="empty">
                <div class="noData"><span>暂无数据</span></div>
            </template>	
        </el-table>
        <!--table表格 e-->
         <!-- S 分页 -->
        <Page v-show="details!=''" :pageTotal="pageTotal" :currentPage="currentPage" :pageSize="pageSize" @nowPageParam="nowPageParam"></Page>
        <!-- E 分页 -->
    </section>
</div>
</template>
<script>
import Api from '@/apis/api';
export default {
    name:'RepaymentManage',
    data(){
        return{
            loading:false,
            showHk:false,
            pageTotal:0, //总数
            currentPage:1, // 页数
            pageSize:30, // 条数
            startvaldate:'',
            endvaldate:'',
            storedisquotachangeList: [],
            details:'',
            detailsTotal:'',
            flowcode:'',
            sellType:this.$route.params.sellType,//销售类型：0：自己；1：有二级分销商
            currentTit:2,//选中的tab
            returnMan:'first',//选中的tab
            distributeForm:{
                time:''
            },
            settleForm:{
                quota:'',
                memo:''
            },//还款表单
           
            tableHeight: window.innerHeight*.8, //表格动态高度
        }
    },
    //================================================ 组件 ================================================
    components: {
        CompanyTabJsz: resolve => require(["@/components/ManageFolder/CompanyTabJsz.vue"],resolve), //头部tab组件
        Page: resolve => require(["@/components/common/Page.vue"], resolve),
        TwoDatePicker: resolve =>require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
    },
    watch:{
        $route() {
           this.sellType=this.$route.params.sellType;//接受路由带过来的变量，控制元素显隐
        }
    },
    //================================================ 方法 ================================================
    methods: {
        // 打开调整额度气泡
        getShowAdd(){
            this.settleForm={
                memo:'',
                quota:'',
            }
        },
        // 关闭开通额度气泡
        getClosePop(){
            document.querySelector("#app").click(); //为了点击空白处关闭弹框
        },
      //开通额度
        updateStoredisquota(val){
          this.showHk = true;
          let reg = (/^(([1-9]\d*)|\d)(\.\d{1,2})?$/);
          if(!reg.test(this.settleForm.quota)){
            this.$message.error('请输入正确的金额！');
            this.showHk = false;
            return
          }
          Api.UPDATESTOREDISQUOTA({type:2,flowcode:this.flowcode,memo:this.settleForm.memo,quota:this.settleForm.quota}).then(res =>{
             if(res.data.status=="200"){
               this.showHk = false;
                this.$message({
                message: res.data.message,
                type: 'success'
              });
               document.querySelector("#app").click(); //为了点击空白处关闭弹框
               this.getStoredisquota();
               this.getStoredisquotachangeList();
             }else{
               this.showHk = false;
               this.$message.error(res.data.message);
             }
          })
        },
      quotas(){
            this.settleForm.quota = this.amountChech(this.settleForm.quota);
        },
        // 选择的日期
        twoDateReceive(val) {
          if(val){
            this.startvaldate = this.dateTime(val[0]);
            this.endvaldate = this.dateTime(val[1]);
          }else{
            this.startvaldate = '';
            this.endvaldate = '';
          }
        },
        //动态获取表格高度
        getHeight() {
            let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
            this.tableHeight = window.innerHeight - tbHeight - 110; 
        },
        //额度详情
        getStoredisquota(){
           Api.GET_STOREDISQUOTA({flowcode:this.flowcode}).then(res =>{
            if(res.data.status=="200"&&res.data.data!=null){
               this.details = res.data.data;
            }else{
               this.details = '';
            }
          })
        },
        getStoredisquotaTotal(){
           Api.GET_STOREDISQUOTATOTAL({}).then(res =>{
              if(res.data.status=="200"&&res.data.data!=null){
               this.detailsTotal = res.data.data;
              }else{
                this.detailsTotal = '';
              }
          })
        },
        nowPageParam(val,vals){
          this.pageSize = val;
          this.currentPage = vals;
          this.getStoredisquotachangeList();
        },
        search(){
          this.currentPage =1;
          this.getStoredisquotachangeList()
        },
        //额度变更记录列表
        getStoredisquotachangeList(){
          this.loading = true;
          let param = {
               flowcode:this.flowcode,
               type:2,
               startvaldate:this.startvaldate,
               endvaldate:this.endvaldate,
               pageparam:{
                    pagesize: this.pageSize, //每页条数
                    currentpage: this.currentPage, //当前页数
              }
          }
          Api.GET_STROEDISQUOTACHANGELIST(param).then(res =>{
               if(res.data.status=="200"){
                 this.loading = false;
                 this.storedisquotachangeList = res.data.data;
                 this.pageTotal = res.data.pagebean.totalnum;
                 this.$refs.gsTable.bodyWrapper.scrollTop = 0;
              }else {
                 this.loading = false;
                 this.pageTotal =0;
                 this.storedisquotachangeList =[];
              }
          })
        }
    },
    //================================================ 生命周期 ================================================
    created() {
        //页面浏览器视窗变化绑定resize事件
        window.addEventListener("resize", this.getHeight);
    },
    mounted() {
        if (this.$route) {
            this.sellType=this.$route.params.sellType;//接受路由带过来的变量，控制元素显隐
        }
        if(this.sellType==0){// this.sellType==0
          if(localStorage.getItem('userInfoMd')){
            let userInfoMd = JSON.parse(localStorage.getItem('userInfoMd'));
            this.flowcode = userInfoMd.flowcode;
          }
            this.getStoredisquota();
            this.getStoredisquotaTotal();
          }else{
            if(this.$route.params.flowcode){
              this.flowcode = this.$route.params.flowcode;
              this.getStoredisquota();
            }
        }
        this.getStoredisquotachangeList();
        //在dom渲染之后
        setTimeout(()=>{
            this.getHeight();
        },200)
    },
    destroyed(){ 
        window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
    }
}
</script>
<style scoped>
.mainPart{
    padding: 20px;
    height: calc(100% - 50px);
}
.quotaTab{
    margin-top:65px;
}
.quotaTab>>>.el-tabs__header{
    margin-bottom:20px;
}
.cardForm{
    margin-top:20px;
}
.quotaWrap{
    display:inline-block;
}
.quotaWrap li{
    margin-right:40px;
    display:inline-block;
    line-height:1.5;
}
.quotaWrap li em{
    display:block;
}
.quotaWrap li strong{
    font-size:20px;
}
.center{
    text-align:center;
}
.priceFont i {color:inherit;}
.pt64 {padding-top: 64px; margin-bottom: 20px;}
.settleForm >>> .el-form-item__content {
    width: 85%;
    min-width: 200px;
    max-width: 300px;
}
.pt20 {padding-top:15px;}
</style>


// WEBPACK FOOTER //
// src/views/ManageFolder/ManageJsz/RepaymentManage.vue